export interface Column {
  key: string;
  label: string;
  group?: string;
}

export const COLUMNS: Column[] = [
  { key: "domain", label: "Domain name" },
  { key: "status", label: "Status" },
  { key: "bought", label: "Bought" },
  { key: "ns", label: "NS" },
  { key: "block_direct_url", label: "Block direct url" },
  { key: "ai_bot_protection_disabled", label: "AI bot protection is disabled" },
  { key: "translated", label: "Translated" },
  { key: "live", label: "Live" },
  { key: "index", label: "Index" },
  { key: "purchase_purpose", label: "Domain purchase purpose" },
  { key: "treasury_comment", label: "Treasury Comment", group: "Jira" },
  { key: "responsible_person", label: "Added by", group: "Jira" },
  { key: "expired", label: "Expired", group: "Jira" },
  {
    key: "redirect_target",
    label: "301 Redirect: Domain to which redirect set/will be set",
    group: "Jira",
  },
  {
    key: "redirect_sources",
    label: "Redirects from domains",
    group: "Jira",
  },
  {
    key: "price",
    label: "Domain price - team",
    group: "Jira",
  },
  {
    key: "registrar",
    label: "Domain registrar - team",
    group: "Jira",
  },
  { key: "site_type", label: "Type", group: "Setup" },
  { key: "platform", label: "Platform", group: "Setup" },
  { key: "domain_type", label: "Type 2", group: "Setup" },
  { key: "geo", label: "GEO", group: "Setup" },
  { key: "cms", label: "CMS", group: "Setup" },
  { key: "official_site", label: "Official Site", group: "Setup" },
  { key: "associated_domains", label: "Associated Domains", group: "Setup" },
  {
    key: "associated_domains_date",
    label: "Associated Domains Date",
    group: "Setup",
  },
  { key: "keyword", label: "Keyword", group: "Setup" },
  { key: "brand_keyword", label: "Keyword (brand)", group: "Setup" },
  { key: "brand_type", label: "Brand Type", group: "Setup" },
  { key: "lang", label: "Lang", group: "Setup" },
  { key: "batch", label: "Batch", group: "Setup" },
  {
    key: "is_hreflang_group",
    label: "Is Hreflang Group",
    group: "Hreflang Group",
  },
  { key: "hreflang_group", label: "Hreflang Group", group: "Hreflang Group" },
  { key: "related_domains", label: "Domains", group: "Hreflang Group" },
  { key: "comment", label: "Comment", group: "Hreflang Group" },
  { key: "offer", label: "Offer", group: "Affiliate" },
  { key: "offer_type", label: "Offer Types", group: "Affiliate" },
  {
    key: "keitaro_source_added",
    label: "Keitaro Source Added",
    group: "Affiliate",
  },
  {
    key: "keitaro_campaign_added",
    label: "Keitaro Campaign Added",
    group: "Affiliate",
  },
  {
    key: "keitaro_campaign_id",
    label: "Keitaro Campaign ID",
    group: "Affiliate",
  },
  {
    key: "campaign_link",
    label: "Campaign Link (only 1-page sites)",
    group: "Affiliate",
  },
  { key: "account_name", label: "Account Name", group: "Analytics" },
  { key: "adspower_id", label: "Adspower ID", group: "Analytics" },
  { key: "gsc_connected", label: "GSC Connected", group: "Analytics" },
  { key: "gsc_api", label: "GSC API", group: "Analytics" },
  { key: "google_analytics", label: "Google Analytics", group: "Analytics" },
  { key: "bing_account", label: "Bing Account", group: "Analytics" },
  { key: "bing_connected", label: "Bing", group: "Analytics" },
  { key: "seogets", label: "Seogets", group: "Analytics" },
  { key: "add_to_dynahosting", label: "Add to Dynahosting", group: "Jetsik" },
  { key: "taxonomy_data", label: "Taxonomy Data", group: "Jetsik" },
  { key: "add_to_domains", label: "Add to Domains", group: "Jetsik" },
  { key: "add_page_content", label: "Add Page - Add Content", group: "Jetsik" },
  { key: "add_page_blocks", label: "Add Page - Add Blocks", group: "Jetsik" },
  { key: "wordpress_setup", label: "Wordpress Setup", group: "Wordpress" },
  { key: "purchase_date", label: "Purchase Date", group: "Timeline" },
  { key: "domain_added_date", label: "Domain added date", group: "Timeline" },
  { key: "date_added_ns", label: "Date to NS", group: "Timeline" },
  {
    key: "date_added_jetsik",
    label: "Date Added to Jetsik",
    group: "Timeline",
  },
  { key: "date_added_wp", label: "Date Added WP", group: "Timeline" },
  { key: "date_added_html", label: "Date Added HTML", group: "Timeline" },
  { key: "activation_date", label: "Activation Date", group: "Timeline" },
  { key: "status_change_date", label: "Status Change Date", group: "Timeline" },
  { key: "link", label: "Link", group: "Link" },
  { key: "www", label: "WWW", group: "Link" },
  { key: "team", label: "Team" },
];
